import $ from 'jquery';
import jQuery from 'jquery';
import whatInput from 'what-input';

window.$ = $;

window.jQuery = jQuery;

import Foundation from 'foundation-sites';
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';

//add pdf renderer

//import './lib/pdf';
//import './lib/pdf.worker';
//import './lib/viewer';

Foundation.addToJquery($); //required for newer versions of foundation

$(document).foundation();


$(document).ready(function(){

	//console.log(window.location.toString());

	//check to see if a document was loaded automatically, if so highlight the appropriate button
	if (window.location.toString().indexOf('?file=') > -1 && window.location.toString().indexOf('?fund=') > -1) {
		//autoloaded document AND fund
		var pdfFileName = window.location.toString().substring(window.location.toString().indexOf('?file=') + 6);
		var fundShortName = window.location.toString().substring(window.location.toString().indexOf('?fund=') + 6, (window.location.toString().lastIndexOf('?')));

		$('.pdfDocButtons a').removeClass('activePDF');
		$('.fundSelectorButtons a').removeClass('activePDF');
		$('.pdfDocButtons').css("display", "none");
		$('#' + fundShortName).css("display", "flex");

		$('.fundSelectorButtons-m a').removeClass('activePDF'); //mobile
		$('#' + fundShortName+"m").css("display", "flex"); //mobile

		$('#' + fundShortName + ' a').each(function() {
			if ($(this).data("pdf") == pdfFileName) {
				$(this).addClass('activePDF');
				// Enables appropriate tab and button
				$(this).parent().css("display", "flex");
				var parentid = $(this).parent().attr('id');
				$('a[data-fundname = '+parentid+']').addClass('activePDF');
				var headName = $('a[data-fundname = '+parentid+']').html();
				$('#fundHeaderName').html(headName);
				return false; //only highlights first match, fixes multiple buttons showing up
			}
		});

		$('#' + fundShortName + 'm a').each(function() {
			if ($(this).data("pdf") == pdfFileName) {
				$(this).addClass('activePDF');
				// Enables appropriate tab and button
				$(this).parent().css("display", "flex");
				var parentid = $(this).parent().attr('id');
				$('a[data-fundname = '+parentid+']').addClass('activePDF');
				var headName = $('a[data-fundname = '+parentid+']').html();
				$('#fundHeaderName').html(headName);
				return false; //only highlights first match, fixes multiple buttons showing up
			}
		});




		$('#mainPDFviewer').data('loadedPdf', pdfFileName);
		PDFViewerApplication.open('assets/pdfs/' + pdfFileName);

	} else if (window.location.toString().indexOf('?fund=') > -1) {
		//this url contains an autoloaded fund, add class to appropriate button
		var fundShortName = window.location.toString().substring(window.location.toString().indexOf('?fund=') + 6);

		$('.pdfDocButtons a').removeClass('activePDF');
		$('.fundSelectorButtons a').removeClass('activePDF');
		$('.pdfDocButtons').css("display", "none");
		$('#' + fundShortName).css("display", "flex");

		$('.fundSelectorButtons-m a').removeClass('activePDF'); //mobile
		$('#' + fundShortName+"m").css("display", "flex"); //mobile

		$('a[data-fundname = '+fundShortName+']').addClass('activePDF');

		var headName = $('a[data-fundname = '+fundShortName+']').html();
		$('#fundHeaderName').html(headName);

		PDFViewerApplication.open('./assets/pdfs/' + $('#' + fundShortName + ' a').first().data("pdf"));
		$('#' + fundShortName + ' a').first().addClass('activePDF');
		$('#mainPDFviewer').data('loadedPdf', $('#' + fundShortName + ' a').first().data("pdf"));
		PDFViewerApplication.open('./assets/pdfs/' + $('#' + fundShortName + 'm a').first().data("pdf"));
		$('#' + fundShortName + 'm a').first().addClass('activePDF');
		$('#mainPDFviewer').data('loadedPdf', $('#' + fundShortName + 'm a').first().data("pdf"));


	} else if (window.location.toString().indexOf('?file=') > -1) {

		//this url contains an autoloaded document, add class to appropriate button
		var pdfFileName = window.location.toString().substring(window.location.toString().indexOf('?file=') + 6);
		$('.pdfDocButtons a').removeClass('activePDF');
		// Disable all tabs
		$('.fundSelectorButtons a').removeClass('activePDF');
		$('.fundSelectorButtons-m a').removeClass('activePDF');  //mobile
		$('.pdfDocButtons').css("display", "none");
		if (pdfFileName.split(".").pop() == "pdf") {
			//this is a PDF
			$('.pdfDocButtons a').each(function() {
				if ($(this).data("pdf") == pdfFileName) {
					$(this).addClass('activePDF');
					// Enables appropriate tab and button
					$(this).parent().css("display", "flex");
					var parentid = $(this).parent().attr('id');
					$('a[data-fundname = '+parentid+']').addClass('activePDF');
					var headName = $('a[data-fundname = '+parentid+']').html();
					$('#fundHeaderName').html(headName);
					return false; //only highlights first match, fixes multiple buttons showing up
				}
			});
			$('#mainPDFviewer').data('loadedPdf', pdfFileName);
		} else if (pdfFileName.split('-')[0] == "Q1_Holdings"){
			var parentid = pdfFileName.split("-")[1];
			var holdingID = pdfFileName.split("-")[2];

			$(".pdfViewerWrapper").css("display", "none");
			$(".holdingscontent").css("display", "block");   	
			$('.pdfDocButtons a').removeClass('activePDF');
		    $("#"+parentid).css("display", "flex");
		    $('.pdfDocButtons a').each(function() {
		    	if($(this).text() == "Q1 Holdings"){
		    		$(this).addClass('activePDF');
		    	}
		    });
			$('a[data-fundname = '+parentid+']').addClass('activePDF');
			var headName = $('a[data-fundname = '+parentid+']').html();
			$('#fundHeaderName').html(headName);
		    $(".ajax-loader").css("display", "block");            
        	getFirstQHoldings(holdingID);
		}else if (pdfFileName.split('-')[0] == "Q3_Holdings"){
			var parentid = pdfFileName.split("-")[1];
			var holdingID = pdfFileName.split("-")[2];

			$(".pdfViewerWrapper").css("display", "none");
			$(".holdingscontent").css("display", "block");   	
			$('.pdfDocButtons a').removeClass('activePDF');
		    $("#"+parentid).css("display", "flex");
		    $('.pdfDocButtons a').each(function() {
		    	if($(this).text() == "Q3 Holdings"){
		    		$(this).addClass('activePDF');
		    	}
		    });
			$('a[data-fundname = '+parentid+']').addClass('activePDF');
			var headName = $('a[data-fundname = '+parentid+']').html();
			$('#fundHeaderName').html(headName);
		    $(".ajax-loader").css("display", "block");            
        	getThirdQHoldings(holdingID);
		} else {
			//not a PDF, do nothing for now
		}
	} else {
		//this url doesn't contain an autoloaded document, load the first available if possible
		//console.log("here");
		var loadfundname = $('.button-group .activePDF').data('fundname');
		$('#' + loadfundname + ' a').first().addClass('activePDF');
		$('#' + loadfundname + 'm a').first().addClass('activePDF');
		PDFViewerApplication.open('./assets/pdfs/' + $('.pdfDocButtons a').first().data("pdf"));
		$('#mainPDFviewer').data('loadedPdf', $('.pdfDocButtons a').first().data("pdf"));
	}

	$('.pdfDocButtons a').click(function(event) {
	    //load the PDF in the viewer based on the button clicked
	    //console.log(this);
	    $(".holdingscontent").html("");
	    $(".holdingscontent").css("display", "none");
	    $('.holdingsbar').css("display", "none");
	    $(".pdfViewerWrapper").css("display", "block");

	    if ($(this).attr('data-pdf')) {
	    	var pdfLink = $(this).data("pdf");
	    	if (pdfLink.split(".").pop() == "pdf") {
		    	//PDFViewerApplication.viewerPrefs.defaultZoomValue = 'page-fit';
		    	PDFViewerApplication.open('assets/pdfs/' + pdfLink);
		    	$('#mainPDFviewer').data('loadedPdf', pdfLink);
		    	$('.pdfDocButtons a').removeClass('activePDF');
		    	$(this).addClass('activePDF');
			} else if(pdfLink == "qholdings"){
				$('.pdfDocButtons a').removeClass('activePDF');
		    	$(this).addClass('activePDF');
			} else {
		      	//don't open, this isn't a PDF
		      	//event.preventDefault();
		  	}
		}
	});

	$('.fundSelectorButtons a').click(function(event) {
	    //choose a new set of documents by clicking a fund
	    //console.log($(this).html());
	    $(".holdingscontent").html("");
	    $(".holdingscontent").css("display", "none");
	    $('.holdingsbar').css("display", "none");
	    $(".ajax-loader").css("display", "none");
	    $(".pdfViewerWrapper").css("display", "block");
    	$('.fundSelectorButtons a').removeClass('activePDF');
    	$('.pdfDocButtons a').removeClass('activePDF');
    	$(this).addClass('activePDF');
    	$('#fundHeaderName').html($(this).html());

    	$('.pdfDocButtons').hide();
    	$('#' + $(this).data('fundname')).fadeIn();
    	var pdfLink = $('#' + $(this).data('fundname') + ' a').first().data("pdf");
    	PDFViewerApplication.open('./assets/pdfs/' + pdfLink);
    	$('#mainPDFviewer').data('loadedPdf', pdfLink);
    	$('#' + $(this).data('fundname') + ' a').first().addClass('activePDF');

	});

	$('.fundSelectorButtons-m a').click(function(event) {
	    //choose a new set of documents by clicking a fund
	    //console.log($(this).html());
	    $(".holdingscontent").html("");
	    $(".holdingscontent").css("display", "none");
	    $('.holdingsbar').css("display", "none");
	    $(".ajax-loader").css("display", "none");
	    $(".pdfViewerWrapper").css("display", "block");
    	$('.fundSelectorButtons-m a').removeClass('activePDF');
    	$('.pdfDocButtons a').removeClass('activePDF');
    	$(this).addClass('activePDF');
    	$('#fundHeaderName').html($(this).html());

    	$('.pdfDocButtons').hide();
    	$('#' + $(this).data('fundname')).fadeIn();
    	var pdfLink = $('#' + $(this).data('fundname') + ' a').first().data("pdf");
    	PDFViewerApplication.open('./assets/pdfs/' + pdfLink);
    	$('#mainPDFviewer').data('loadedPdf', pdfLink);
    	$('#' + $(this).data('fundname') + ' a').first().addClass('activePDF');

	});

	$(document).on("closeme.zf.reveal", function(e){
	  console.log(e);
	  if (e.target.id == "emailRequest") {
	  	//email was opened
	  	$('#submitEmailRequest_EmailAddress').val('');
	  	$('#emailRequestInputZone').show();
		$('#emailRequestButtonZone').show();
		$('#emailSuccessResponseZone').hide();
	  } else {
	  	//do nothing
	  }
	});

	$('#submitEmailRequest').click(function(event) {
		var emailAddress = $('#submitEmailRequest_EmailAddress').val().trim(); 
		//alert($('#mainPDFviewer').data('loadedPdf'));
		if (validateEmail(emailAddress)) {

			var documentName = $('#mainPDFviewer').data('loadedPdf');
			//var sender = 'info@yorktownfunds.com';
			var receiver = emailAddress; 
			//var emailSubject = 'Email Document Request - Yorktown Funds'; 
			//var fundGroup = 'yorktown'; 
		
			$.ajax({
				url: "../fp_docs_test.php", 
				method: "post", 
				data: { "document":documentName,"sender":sender,"receiver":receiver,"subject":emailSubject,"fundGroup":fundGroup},
				success: function(data){
					//email worked
					$('#emailRequestInputZone').fadeOut();
					$('#emailRequestButtonZone').fadeOut();
					$('#emailSuccessResponse').html('Your email was sent successfully.');
					$('#emailSuccessResponseZone').fadeIn();
				},
				 error: function() {
					//email didn't work
					$('#emailSuccessResponse').html('Sorry, your email was not sent successfully. Double-check the entered email address or try downloading the file using the "download" button.');
					$('#emailSuccessResponseZone').fadeIn();
				} 
			});
		} else {
			alert('Please enter a valid email address.');
		}
	});

	$('.first-q-holdings-link').on('click', function(){
        var holdingId = $(this).data("id");
        $('#pdfdownload').removeClass();
        $(".holdingscontent").css("display", "block");
        $(".holdingscontent").html("");
        $('.holdingsbar').css("display", "none");
        $(".pdfViewerWrapper").css("display", "none");
        $(".ajax-loader").css("display", "block");            
        getFirstQHoldings(holdingId);
    });

    $('.third-q-holdings-link').on('click', function(){
        var holdingId = $(this).data("id");
        $('#pdfdownload').removeClass();
        $(".holdingscontent").css("display", "block"); 
        $(".holdingscontent").html("");
        $('.holdingsbar').css("display", "none");
        $(".pdfViewerWrapper").css("display", "none");
        $(".ajax-loader").css("display", "block");            
        getThirdQHoldings(holdingId);
    });

    $('.third-q-holdings-link-notfiled').on('click', function(){
        var holdingUrl = $(this).data("holdingurl");
        $('#pdfdownload').removeClass();
        $(".holdingscontent").css("display", "block"); 
        $(".holdingscontent").html("");
        $('.holdingsbar').css("display", "none");
        $(".pdfViewerWrapper").css("display", "none");
        $(".ajax-loader").css("display", "block");            
        getThirdQHoldingNotFiled(holdingUrl);
    });

    $('#pdflink').on('click', function(e){
	    e.preventDefault();
	    printHoldings();
	});

	$('.archiveButton').on('click', function(e){
	    e.preventDefault();
	});


	$('#pdfdownload').on('click', function(e){
	    e.preventDefault();
	    CreatePDFfromHTML();
	    $(".pdf-loader").css("display", "inline-block");
	});

});

function getFirstQHoldings(holdingId){
  console.log(holdingId);

  var holdingsURL = "https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK="+holdingId+"&type=NPORT-P&dateb=&owner=exclude&output=xml&count=10";


  $.ajax({
    type: 'POST',
    url: './assets/php/first-quarter-link.php',
    data: {'holdingslink': holdingsURL},
    dataType: 'text'
  })
  .done( function( data ) {
  	console.log(data);

    $('.ajax-loader').css("display", "none");
    $(".holdingscontent").html(data);
    if(data){
    	$('.holdingsbar').css("display", "block");
    	$('#pdfdownload').addClass("Q1");
    }  
    
  })
  .fail( function( data ) {
      console.log('fail');
      console.log(data);
  });

}

function getThirdQHoldings(holdingId){
  console.log(holdingId);

  var holdingsURL = "https://www.sec.gov/cgi-bin/browse-edgar?action=getcompany&CIK="+holdingId+"&type=NPORT-P&dateb=&owner=exclude&output=xml&count=10";

  $.ajax({
    type: 'POST',
    url: './assets/php/third-quarter-link.php',
    data: {'holdingslink': holdingsURL},
    dataType: 'text'
  })
  .done( function( data ) {

  	$('.ajax-loader').css("display", "none");
    $(".holdingscontent").html(data);
    if(data){
    	$('.holdingsbar').css("display", "block");
    	$('#pdfdownload').addClass("Q3");
    }

  })
  .fail( function( data ) {
      console.log('fail');
      console.log(data);
  });

}

function getThirdQHoldingNotFiled(holdingUrl){
  console.log(holdingUrl);

  $.ajax({
    type: 'POST',
    url: './assets/php/third-quarter-link-notfiled.php',
    data: {'holdingslink': holdingUrl},
    dataType: 'text'
  })
  .done( function( data ) {

  	//console.log(data);

  	$('.ajax-loader').css("display", "none");
    $(".holdingscontent").html(data);
    if(data){
    	$('.holdingsbar').css("display", "block");
    }

  })
  .fail( function( data ) {
      console.log('fail');
      //console.log(data);
  });

}

function validateEmail(email) 
{
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function printHoldings(){
  var mywindow = window.open('', 'PRINT', 'height=400,width=600');

  mywindow.document.write('<html><head><title>SBH Holdings</title>');
  mywindow.document.write('</head><body >');
  mywindow.document.write('<h1>Holdings</h1>');
  mywindow.document.write(document.getElementById("holdingscontent").innerHTML);
  mywindow.document.write('</body></html>');

  mywindow.document.close(); // necessary for IE >= 10
  mywindow.focus(); // necessary for IE >= 10*/

  mywindow.print();
  mywindow.close();

  return true;
}

function CreatePDFfromHTML(quarter) {
	let _data = {
	  html: document.getElementById('holdingscontent').innerHTML,
	}

	console.log(_data);

    fetch('//sitedev.filepoint.com/htmlToPDF.php', {method: 'POST', body: JSON.stringify(_data), headers: {"Content-type": "application/json; charset=UTF-8"}})
        .then(r => r.blob())
		.then(showFile);
}

function showFile(blob){
	var quarter = $('#pdfdownload').attr("class");
  // It is necessary to create a new blob object with mime-type explicitly set
  // otherwise only Chrome works like it should
  console.log(quarter);
  var newBlob = new Blob([blob], {type: "application/pdf"})

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  } 

  // For other browsers: 
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob);
  var link = document.createElement('a');
  link.href = data;
  link.download= quarter+"_Holdings.pdf";
  link.click();
  setTimeout(function(){
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
  $(".pdf-loader").css("display", "none");
}
